import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mallUrl: 'https://mall.console.hzhaya.com',
    iotUrl: 'https://console.hzhaya.com/#/Aiot/index',
    cookieDomain: ";path=/; domain=.hzhaya.com",
    // mallUrl: 'http://192.168.124.11:8081/',
    //  iotUrl: 'http://192.168.124.11:8080/#/Aiot/index',
    //  cookieDomain: ""
  },
  getters: {
    getCookieDomain(state) {
      return state.cookieDomain
    },
    getMallUrl(state) {
      return state.mallUrl
    },
    getIotUrl(state) {
      return state.iotUrl
    },
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
